/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PresentPreferenceParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('present')],
    ['value', codec.unknown],
]);
export class PresentPreference extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PresentPreferenceParser.decode(input).map(res => new PresentPreference(res));
    }
    static unsafeDecode(input) {
        return PresentPreference.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PresentPreferenceParser.encode(data);
    }
    static schema() {
        return PresentPreferenceParser.schema();
    }
}
